import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=49489952&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=49489952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49489952",
  null
  
)

export default component.exports